import { render, staticRenderFns } from "./detailMsgCopy.vue?vue&type=template&id=7f01c444&scoped=true&"
import script from "./detailMsgCopy.vue?vue&type=script&lang=js&"
export * from "./detailMsgCopy.vue?vue&type=script&lang=js&"
import style0 from "./detailMsgCopy.vue?vue&type=style&index=0&id=7f01c444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01c444",
  null
  
)

export default component.exports